import { Controller } from "@hotwired/stimulus"

const PREFIX = 'media_library_filter_'
const FIELDS = ['media_type', 'search', 'sort_by', 'per_page', 'usage']

export default class extends Controller {
  connect() {
    const form = this.element.querySelector('form')
    if (!form) return

    const urlParams = new URLSearchParams(window.location.search)

    if (FIELDS.some(f => urlParams.has(f))) {
      this.syncFromUrl(urlParams)
    } else {
      this.restoreIfNeeded(form)
    }
  }

  save(event) {
    const form = event.target
    FIELDS.forEach(field => {
      const el = form.elements[field]
      if (!el) return
      if (el.value) {
        sessionStorage.setItem(PREFIX + field, el.value)
      } else {
        sessionStorage.removeItem(PREFIX + field)
      }
    })
  }

  clear() {
    FIELDS.forEach(field => sessionStorage.removeItem(PREFIX + field))
  }

  syncFromUrl(urlParams) {
    FIELDS.forEach(field => {
      const val = urlParams.get(field)
      if (val) {
        sessionStorage.setItem(PREFIX + field, val)
      } else {
        sessionStorage.removeItem(PREFIX + field)
      }
    })
  }

  restoreIfNeeded(form) {
    const toRestore = {}
    FIELDS.forEach(field => {
      const val = sessionStorage.getItem(PREFIX + field)
      if (val) toRestore[field] = val
    })

    if (Object.keys(toRestore).length === 0) return

    FIELDS.forEach(field => {
      const el = form.elements[field]
      if (el && toRestore[field]) el.value = toRestore[field]
    })

    form.requestSubmit()
  }
}
